define([
        'core/browser-storage',
        'core/constants',
        'components/daterangepicker-v2',
        'core/iterate',
        'core/utilities',
        'moment',
    ], function (
        browser_storage,
        constants,
        drp,
        iterate,
        utilities,
        moment
    ) 
{
    let nodes = {
        pageHeader: document.querySelector(".page-header.status-and-settings"),
        pageSettingsToggle: document.querySelector(".page-settings-toggle-wrap"),
        filterSettingsToggle: document.querySelector(".filter-toggle-wrap"),
        filterSettingsToggleLabel: document.querySelector(".filter-toggle-wrap .label"),
        filterSettings: document.querySelector(".settings-panel.filter-settings"),
        settingsPanel: document.querySelector(".settings-panel"),
        filterLimiters: document.querySelectorAll(".limit-responses .mini-toggle input"),
        filterStatus: document.querySelector(".filter-status"),
        filtersReset: document.querySelector(".reset-settings"),
        preserveFiltersToggle: document.querySelector("#preserveFiltersToggle"),
        dateStatus: document.querySelector(".page-header .date-range #datepicker"),
    }

    let filterParams = {}
    let filterData = {};
    let nestedSurveyId;
    let usingNestedId = false;
    let returnedFilterData;

    let defaultDateRange = [moment().subtract(90, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];

    // params specific to date selections
    let dateParams = {
        preset: "Last 90 days",
        date: defaultDateRange,
    }

    let initialDateParams = {
        preset: "Last 90 days",
        date: defaultDateRange,
    }

    let returnParams;
    let pagePrefix;

    // this is currently only used in NPS, but added for future potential updates to CSAT/Projects
    let availableColumns = [];

    let preserveFilters = false;

    let getFilterData = async (endpoint) => {
        if(!endpoint) return;

        const response = await fetch(endpoint, {
            method: "GET",
            headers: {
            Accept: "application/json",
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.json();
    }

    let showPreservedFilters = () => {
        if(preserveFilters === "false" || preserveFilters === false) return;

        iterate(filterParams, (selections, category) => {
            if((filterData[category] && (!filterData[category].variant || filterData[category].variant === "search")) && filterParams[category].length > 0) {
                filterParams[category].forEach(selection => {
                    let toggleOption = document.querySelector(`.selector[data-id='${category}'] .filter-options .option[data-id='${encodeURIComponent(selection)}']`);
                    toggleFilter(toggleOption, category, true);
                    activeFilters = true;
                })
            }

            if(filterData[category] && filterData[category].variant === "radio" && filterParams[category] !== "0") {
                let toggleOption = document.querySelector(`.selector[data-id='${category}'] .filter-options .option[data-id='${selections}']`);
                toggleFilter(toggleOption, category, true);
                activeFilters = true;
            }

            if((category === "is_primary" || category === "is_billing") && filterParams[category] === true) {
                document.querySelector(`.limit-responses input[data-field='${category}']`).checked = true;
                activeFilters = true;
                utilities.updateFilterStatus(filterParams);
            } 
        });            

        // render saved date range 
        let storedDateParams = browser_storage.getItem(`${pagePrefix}-date-params`, nestedSurveyId);
        dateParams = storedDateParams ? JSON.parse(storedDateParams) : structuredClone(initialDateParams);
        utilities.updateDateStatus(dateParams, nodes.dateStatus, true);
    }

    // deselect filter chip
    let deselectFilter = (filterId, categoryId) => {
        let filterWrap = document.querySelector(`.filter-wrap[data-id='${categoryId}']`);
        let filterSelections = filterWrap.querySelector(".selections");
        let selectionElement = filterSelections.querySelector(`[data-id='${filterId}']`);
        let filterOptionElement = filterWrap.querySelector(`.filter-options .option[data-id='${filterId}']`);
        let filterVariant = filterWrap.getAttribute("data-filter-variant");
        let dataType = filterWrap.getAttribute("data-type");

        // deselect filter option in dropdown
        filterOptionElement.classList.remove("selected");
        // remove selection
        selectionElement.remove();

        if(filterVariant === "radio" || filterVariant === "boolean") {
            let defaultValue = filterData[categoryId].default;
            filterParams[categoryId] = defaultValue;
            filterSelections.querySelector(".selection.all").classList.remove("hide");
        } else {
            // remove filter selection from params
            filterParams[categoryId] = filterParams[categoryId].filter(
                item => item !== (dataType === "int" ? decodeURIComponent(filterId) * 1 : decodeURIComponent(filterId))
            );

            // show the 'all' selection if no other filters selected
            if (!filterParams[categoryId].length) {
                filterSelections.querySelector(".selection.all").classList.remove("hide");
            }
        }

        // re-activate filter option in dropdown
        filterWrap.querySelector(`.filter-options .option[data-id='${filterId}']`).classList.remove("selected");

        utilities.updateFilterStatus(filterParams, () => {
            utilities.setSettingsHeight(nodes);
        });

        returnParams();
    }

    let toggleFilter = (chosenFilterElement, categoryId, togglingPreset) => {
        if(categoryId === "is_primary" || categoryId === "is_billing" || !chosenFilterElement) return;
        let filterId = chosenFilterElement.getAttribute("data-id");
        let filterWrap = document.querySelector(`.filter-wrap[data-id='${categoryId}']`)
        let filterSelections = filterWrap.querySelector(".selections");
        let filterVariant = filterWrap.getAttribute("data-filter-variant");
        let dataType = filterWrap.getAttribute("data-type");

        if (chosenFilterElement.classList.contains("selected")) {
            deselectFilter(filterId, categoryId)
            return;
        }
        
        if (!filterParams[categoryId].length || filterVariant === "radio" || filterVariant === "boolean" || togglingPreset) {
            // hide the 'all' selection if not already hidden
            filterSelections.querySelector(".selection.all").classList.add("hide");
        }

        // add filter selection to filter params
        if (filterVariant === "radio" || filterVariant === "boolean") {
            // clear previous selections for radio type options
            if(!togglingPreset) filterParams[categoryId] = dataType === "int" ? filterId * 1 : filterId;
            let dropdownSelection = filterWrap.querySelector(".option.selected");
            let selectedChip = filterWrap.querySelector(".selection:not(.all)");
            if(dropdownSelection) dropdownSelection.classList.remove("selected");
            if(selectedChip) selectedChip.remove();
        } else {
            if(!togglingPreset) filterParams[categoryId].push(
                dataType === "int" ? decodeURIComponent(filterId) * 1 : decodeURIComponent(filterId)
            );
        }

        // add 'selected' state to filter option in dropdown
        chosenFilterElement.classList.add("selected");

        // create new filter chip
        let newSelectionElement = document.createElement("div");
        newSelectionElement.classList.add("selection");
        newSelectionElement.setAttribute("data-id", filterId)
        newSelectionElement.innerHTML = `${chosenFilterElement.innerHTML}<span class="remove">✕</div>`;

        // add deselect filter event listener
        newSelectionElement.addEventListener("click", (event) => {
            deselectFilter(filterId, categoryId)
        });

        // add new filter to selections
        filterSelections.prepend(newSelectionElement);

        utilities.updateFilterStatus(filterParams, () => {
            utilities.setSettingsHeight(nodes);
        });

        if(!togglingPreset) {
            returnParams();
        }
    }

    let clearSearch = (categoryId) => {
        let search = document.querySelector(`.filter-wrap .selector[data-id="${categoryId}"] .filter-search`);
        if(!search) return;
        
        search.value = '';

        //simulate input event for search to trigger event listener
        let event = document.createEvent('Event');
        event.initEvent('input', true, true);
        search.dispatchEvent(event);
    }

    let closeAllSelectors = (currentId) => {
        let selectors = document.querySelectorAll(".filter-wrap .selector.active");

        selectors.forEach(selector => {
            if(currentId) {
                // exclude current selector if required
                if(selector.getAttribute("data-id") !== currentId) {
                    selector.classList.remove("active");
                }
            } else {
                selector.classList.remove("active");
            }
        })
    }

    let initSettingsReset = (togglingPreset) => {
        dateParams = {
            preset: "Last 90 days",
            date: defaultDateRange,
        }
        
        iterate(filterParams, (value, key) => {
            if(constants.defaultFilterParams[pagePrefix][key]) {
                filterParams[key] = constants.defaultFilterParams[pagePrefix][key]
            } else {
                filterParams[key] = [];
            } 
        });

        document.querySelectorAll(".selection:not(.all)").forEach(selection => {
            selection.parentElement.querySelector(".all").classList.remove("hide");
            selection.remove();
        })

        document.querySelectorAll(".option.selected").forEach(option => {
            option.classList.remove("selected");
        })

        if(nodes.filterLimiters) {
            nodes.filterLimiters.forEach(input => {
                input.checked = false;
            })
        }

        nodes.filterStatus.classList.remove("active");
        nodes.filterStatus.innerText = "No filters selected";

        nodes.dateStatus.innerText = dateParams.preset.toLowerCase();

        drp.reset();

        if(!togglingPreset) {
            returnParams();
        }
    }

    let filterEventListeners = () => {
        let allSelectors = document.querySelectorAll(".filter-wrap .selector");

        allSelectors.forEach(selector => {
            let categoryId = selector.getAttribute("data-id");
            let search = selector.querySelector(".filter-search");

            selector.querySelector(".filter-name").addEventListener("click", () => {
                closeAllSelectors(categoryId);
                if(selector.classList.contains("active")) {
                    selector.classList.remove("active");
                }else {
                    clearSearch(categoryId);
                    selector.classList.add("active");
                }
            })

            let options = selector.querySelectorAll(".filter-options .option");

            options.forEach(option => {
                option.addEventListener("click", () => {
                    toggleFilter(option, categoryId);
                })
            })

            // add filter search
            if(search) {
                search.addEventListener("input", (event) => {   
                    let results = false;               
                    
                    options.forEach(option => {
                        let match = option.innerText.toLowerCase().indexOf(event.target.value.toLowerCase());
                        if(match > -1) {
                            option.classList.remove("hide");
                            results = true;
                        } else {
                            option.classList.add("hide");
                        }
                    })
                })
            };
        })

        nodes.filtersReset.addEventListener("click", () => {
            initSettingsReset();
        })

        if(nodes.filterLimiters) {
            nodes.filterLimiters.forEach(limiter => {
                limiter.addEventListener("change", (event) => {
                    let field = event.currentTarget.getAttribute("data-field");
                    
                    if(event.target.checked) {
                        filterParams[field] = true;
                    } else {
                        filterParams[field] = [];
                    }

                    returnParams();
                    utilities.updateFilterStatus(filterParams);
                });
            });
        }

        nodes.settingsPanel.addEventListener("click", (event) => {
            if(!event.target.classList.contains('selector') && !event.target.classList.contains('filter-name') && !event.target.classList.contains('filter-search')) {
                closeAllSelectors();
            }
        })            
    }

    let getFilterParams = () => {
        let params = {...filterParams};
        if(pagePrefix === "csat-reviews" || pagePrefix === "csat-analytics") {
            params['start_date'] = drp.getStartDate().format("YYYY-MM-DD");
            params['end_date'] = drp.getEndDate().format("YYYY-MM-DD");
        }

        return params;
    }

    let renderFilters = async (endpoint, onReady, passedFilterData) => {

        let output = '';

        returnedFilterData = endpoint ? await getFilterData(endpoint) : passedFilterData;

        iterate(returnedFilterData.filters ? returnedFilterData.filters : returnedFilterData, (value, key) => {
            filterData[key] = {
                values: value,
                variant: "search",
            }

            if(preserveFilters === false || preserveFilters === "false") {
                filterParams[key] = [];
            }
            
            availableColumns.push(key);
            
        });
        
        // iterate through constants.filterNameMapping to determine correct order of filters
        iterate(constants.filterNameMapping, (value, key) => {
            // only render filters that have been returned with data
            if(filterData[key]) {
                let options = filterData[key];
                let optionList = typeof(options) === 'object' ? options.values : options;

                if (optionList === null) optionList = []; 

                let filterOptions = optionList.map(option => { 
                    let name = "";
                    let id = "";
                    
                    if(key === "ratings") {
                        // for ratings filter, we want to show the sentiment icons instead of text, so we use the name field to store the HTML for the icons
                        name = option.name;
                    } else if(key === "triggers") {
                        let nameString = option.name ? `${option.name}` : "Project Status";
                        name = utilities.sanitizeData(`${nameString} - ${option.status}`);
                    } else if(key === "contacts") {
                        name = utilities.sanitizeData(`${option.first_name} ${option.last_name}`);
                    } else {
                        if(option && option.name && option.name !== null) {
                            name = utilities.sanitizeData(option.name);
                        } else if(option && option !== null) {
                            name = utilities.sanitizeData(option);
                        }
                    }

                    if(option && (option.id || option.id === false) && option.id !== null) {
                        id = option.id;
                    } else if(option && option !== null) {
                        id = option;
                    }
                    
                    // We have to encode filter names when storing them as data  
                    // attributes, so they don't get converted to HTML in rare cases.
                    // Then we decode them when adding the data to the filter params.
                    return `<div class="option" data-id="${encodeURIComponent(id)}">${name}</div>`
                }).join('')

                let search = options.variant === 'search' && optionList.length > 6 ? `
                    <div class="search-wrap">
                    <input class='filter-search' type="text" placeholder="Search ${constants.filterNameMapping[key].plural}">
                </div>` : '';

                let optionsOutput = optionList.length > 0 ? (
                    `<div class="options-wrap">
                        ${filterOptions}
                    </div>`
                ) : `<div class="no-results">No results found</div>`;

                let tooltip = value.tooltip ? (
                    `<span class="tooltip-wrap">
                        <img src="/static/icons/info.svg" alt="">
                        <div class="sb-tooltip">
                            ${value.tooltip}
                        </div>
                    </span>`
                ) : '';

                output += `
                    <div class="filter-wrap" data-type="${options.dataType || "string"}" data-filter-variant="${options.variant}" data-id="${key}">
                        <div class="selector" data-id="${key}">
                            <div class="filter-name">
                                ${constants.filterNameMapping[key].singular}
                            </div>
                            <div class="filter-options">
                                ${search}
                                ${optionsOutput}
                            </div>
                        </div>
                        <div class="selection-tooltip-wrap">
                            <div class="selections"><div class="selection all">All ${constants.filterNameMapping[key].plural}</div></div>
                            ${tooltip}
                        </div>
                    </div>
                `
            }                
        })

        document.querySelector(".all-filters").innerHTML = output;

        filterEventListeners();
        showPreservedFilters();
        utilities.setSettingsHeight(nodes, true);

        filtersRendered = true;

        onReady && onReady(returnedFilterData, availableColumns, filterParams);
    }

    [nodes.pageSettingsToggle,nodes.filterSettingsToggle, nodes.filterStatus].forEach(node => {
        if(!node) return;
        node.addEventListener("click", (event) => {
            event.stopPropagation();
            nodes.filterSettingsToggle.classList.contains("active") ? nodes.filterSettingsToggle.classList.remove("active") : nodes.filterSettingsToggle.classList.add("active");
            nodes.settingsPanel.classList.contains("hide") ? nodes.settingsPanel.classList.remove("hide") : nodes.settingsPanel.classList.add("hide");
        })
    });

    window.addEventListener('resize', () => {utilities.setSettingsHeight(nodes)});

    utilities.setSettingsHeight(nodes, true);

    return {
        create: function (prefix, endpoint, onChange, onReady, passedFilterData, nestedId) {
            // nested IDs are used for projects survey results page, 
            // to differentiate filters for different surveys 
            if(nestedId) {
                nestedSurveyId = nestedId;
                usingNestedId = true;
            }

            preserveFilters = browser_storage.getItem(`preserve-${prefix}-filters`) === "true" ? true : false;

            // filterData is the data used to render the filters
            // filterParams is the data structure used to store the selected filters and send to the backend 
            filterData = {...constants.staticFilterData[prefix]};
            let storedFilterParams = browser_storage.getItem(`${prefix}-filters`, nestedSurveyId);
            filterParams = preserveFilters && storedFilterParams ? JSON.parse(storedFilterParams) : {...constants.defaultFilterParams[prefix]};
            pagePrefix = prefix;

            let drpCalendar = document.querySelector(".calendar-presets-wrap");
            
            // check if DRP is already rendered
            if(!drpCalendar) {
                drp.create((selection) => {
                    if (preserveFilters) {
                        drp.saveToBrowserStorage(pagePrefix, nestedSurveyId);
                    }

                    onChange(getFilterParams(), drp.getDateParams());
                }, true);

                if (preserveFilters) {
                    nodes.preserveFiltersToggle.checked = true;
                    utilities.updateFilterStatus(filterParams   );
                    drp.loadFromBrowserStorage(prefix, nestedSurveyId);
                    utilities.updateDateStatus(drp.getDateParams(), nodes.dateStatus, true);
                }
            }

            returnParams = () => {
                if(preserveFilters === true) {
                    browser_storage.setItem(pagePrefix + '-filters', JSON.stringify(getFilterParams()), nestedSurveyId);
                }    

                onChange(getFilterParams(), drp.getDateParams());
            };

            nodes.preserveFiltersToggle.addEventListener("click", (event) => {
                if(event.target.checked) {
                    preserveFilters = true;

                    browser_storage.setItem(`preserve-${prefix}-filters`, "true");

                    browser_storage.setItem(`${prefix}-filters`, JSON.stringify(filterParams), nestedSurveyId);
                    drp.saveToBrowserStorage(prefix, nestedSurveyId);
                } else {
                    preserveFilters = false;
                    browser_storage.setItem(`preserve-${prefix}-filters`, "false");
                    browser_storage.removeItem(`${prefix}-filters`);
                    drp.removeFromBrowserStorage(`${prefix}`);
                }
            });

            renderFilters(endpoint, onReady, passedFilterData);            
        },
        reset: () => {
            initSettingsReset(true);
        },
        destroy: () => {
            document.querySelector(".all-filters").innerHTML = '';
        },
        getFilterParams: getFilterParams,
    }
});
